/**
 * Created by pmnia on 7/1/15.
 */
//blocks requie.js
require('./logger/logger.module.js');
require('./logger/logger.js');

require('./exception/exception.module.js');
require('./exception/exception.js');
require('./exception/exception-handler.provider.js');

require('./modal/modal.module.js');
require('./modal/obt-modal.directive.js');
require('./modal/obt-modal.service.js');
require('./modal/obt-modals.controller.js');
require('./modal/obt-modals.directive.js');
require('./modal/obt-modalWrapper.directive.js');

require('./router/router.module.js');
require('./router/router-helper.provider.js');

require('./storage/storage.module.js');
require('./storage/reminder.service.js');
require('./storage/session.service.js');
require('./storage/storage.service.js');



/*****************
 ** WEBPACK FOOTER
 ** ./app/blocks/blocks.require.js
 ** module id = 80
 ** module chunks = 0
 **/